const styles = () => ({
  alert: {
    position: 'static',
    paddingTop: '4px',
    paddingBottom: '4px',
    width: '100%',
  },
});

export default styles;